import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';
import { openSidepanel, TEMPLATES_SIDEPANEL_ID, TEMPLATES_SLIDERS_ID } from '@/js/shared/sidepanel';
import { markTemplateSource, MODAL_SOURCE } from '@/js/shared/template_source';

const SLIDE_SELECTOR = 'template[data-role="collection-slide"]';

export default class extends Controller {
  #picked = false;

  connect() {
    this.#dialog?.addEventListener('close', this.#closed);
  }

  disconnect() {
    this.#dialog?.removeEventListener('close', this.#closed);
  }

  // The panel's thumb skips its own append once this slide exists, so it cannot duplicate it.
  openCollection({ currentTarget }) {
    markTemplateSource(MODAL_SOURCE);
    openSidepanel(TEMPLATES_SIDEPANEL_ID);
    this.#openSlide(currentTarget.querySelector(SLIDE_SELECTOR));
    this.#picked = true;
    this.#dialog.close();
  }

  #closed = () => {
    if (this.#picked) {
      return;
    }

    this.dispatch('applyBlankBoard', { target: document });
    this.dispatch('closed', { target: document });
  };

  #openSlide(template) {
    if (!template) {
      return;
    }

    const slide = templateContent(template);
    if (document.getElementById(slide.id)) {
      return;
    }

    document.getElementById(TEMPLATES_SLIDERS_ID).appendChild(slide);
  }

  get #dialog() {
    return this.element.closest('dialog');
  }
}
